import React, { useState, useEffect, useContext, useMemo } from "react";
import { AuthContext } from "../../../contexts/AuthContext";
import Header from "../../../layout/Header/Header";
// import Footer from "../../layout/Footer/Footer";
import {
  Button,
  Row,
  Table,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Input,
  Label,
  ButtonGroup,
  Col,
  Spinner
} from "reactstrap";
import SweetAlert from "sweetalert2-react";
import Swal from "sweetalert2";
import { jsPDF } from "jspdf";
import "jspdf-autotable";
import autoTable from "jspdf-autotable";
import ExportJsonExcel from "js-export-excel";
import { encode } from "base64-arraybuffer";
import axios from "axios";
import Baja from "../../Baja";
import { TableHeader, Pagination, Search } from "../../../DataTable";
import useFullPageLoader from "../../../hooks/useFullPageLoader";
import qrcode from "qrcode-js";
import { v4 as uuidv4 } from "uuid";
import moment from 'moment';

function ListadoSurtidos() {
  const { user } = useContext(AuthContext);
  const URL_SURTIDOS = process.env.REACT_APP_URL_SURTIDOS;
  const URL_CLIENTES = process.env.REACT_APP_URL_CLIENTES;
  const URL_SEND_MAIL_ATT = process.env.REACT_APP_URL_SEND_MAIL_ATT;
  const URL_ARTICULOS_EMBARQUES = process.env.REACT_APP_URL_ARTICULOS_EMBARQUES;
  const URL_ARTICULOS_SURTIDOS = process.env.REACT_APP_URL_ARTICULOS_SURTIDOS;
  const URL_IMEIS = process.env.REACT_APP_URL_IMEIS;
  const URL_PAQUETERIAS = process.env.REACT_APP_URL_PAQUETERIAS;

  let hoy = new Date()
  let inicio = new Date()
  inicio.setDate(inicio.getDate()-90);
 
  let endDate   = moment(hoy).format("YYYY-MM-DD"); 
  let startDate   = moment(inicio).format("YYYY-MM-DD");

  const [surtidos, setSurtidos] = useState([]);

  const [clientes, setClientes] = useState([]);
  const [selectedCliente, setSelectedCliente] = useState("");
  const [selectedUser, setSelectedUser] = useState("");

  const [selectedFechaInicio, setSelectedFechaInicio] = useState(startDate);
  const [selectedFechaFin, setSelectedFechaFin] = useState(endDate);
  const [autorizadoSurtido, setAutorizadoSurtido] = useState("");

  const [modalMail, setModalMail] = useState(false);
  const toggleMail = () => setModalMail(!modalMail);
  const [modalIMEI, setModalIMEI] = useState(false);
  const toggleIMEI = () => setModalIMEI(!modalIMEI);
  const [imeiDocId, setImeiDocId] = useState("");
  const [imeiDocNumero, setImeiDocNumero] = useState("");
  const [imeiDocFecha, setImeiDocFecha] = useState("");
  const [imeisList, setImeisList] = useState([]);
  const [newIMEI, setNewIMEI] = useState("");
  const [newIMEIArticulo, setNewIMEIArticulo] = useState("");
  const [mailTo, setMailTo] = useState("");

  const [activo, setActivo] = useState("");

  const [cargando, setCargando] = useState(true);
  const [modalEntregar, setModalEntregar] = useState(false);
  const toggleEntregar = () => setModalEntregar(!modalEntregar);
  const [paqueterias, setPaqueterias] = useState([]);
  const [selectedPaqueteria, setSelectedPaqueteria] = useState("");
  const [surtidosPaqueteria, setSurtidosPaqueteria] = useState([]);
  const [idsArticulo, setIdsArticulo] = useState([]);
  const [surtidosPaqueteriaGuarda, setSurtidosPaqueteriaGuarda] = useState([]);
  const [articulos, setArticulos] = useState([]);

  const [modalProgreso, setModalProgreso] = useState(false);
  const toggleProgreso = () => setModalProgreso(!modalProgreso);

  const [rollos, setRollos] = useState([]);

  //--- Pagination
  const [comments, setComments] = useState([]);
  const [loader, showLoader, hideLoader] = useFullPageLoader();
  const [totalItems, setTotalItems] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [search, setSearch] = useState("");
  const [sorting, setSorting] = useState({ field: "", order: "" });

  // const classes = useStyles();
  const [inputFields, setInputFields] = useState([
    {
      id: uuidv4(),
      _id: "",
      articulo: "",
      cliente: "",
    },
  ]);

  const ITEMS_PER_PAGE = 50;

  const Toast = Swal.mixin({
      toast: true,
      position: "center",
      showConfirmButton: false,
      // timer: 5000,
      timerProgressBar: true,
      didOpen: (toast) => {
        toast.addEventListener("mouseenter", Swal.stopTimer);
        toast.addEventListener("mouseleave", Swal.resumeTimer);
      },
    });
    if (cargando) {
      Toast.fire({
        html: `<i class="fas fa-hourglass-half custom-spin fa-2x" style="margin-right: 16px;"></i>`, // Ícono de carga animado
      title: "Danos unos segundos....",
      customClass: {
        icon: 'animated-icon'
      }
      });
    }
  useEffect(() => {
    axios
      .get(URL_CLIENTES, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allClientes = response.data;
        setClientes(allClientes);
      })
      .catch((err) => {
        console.log(err);
      });
      axios
        .get(URL_PAQUETERIAS, {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        })
        .then((response) => {
          let allPaqueterias = response.data;
          setPaqueterias(allPaqueterias);
        })
        .catch((err) => {
          console.log(err);
        });
  }, []);

  useMemo(()=>{
    axios
    .get(`${URL_SURTIDOS}Fechas/${selectedFechaInicio}/${selectedFechaFin}`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allSurtidos = response.data;
        // Array para pagination
        let arrayTabla = allSurtidos
          .sort((a, b) => (a.idSurtido > b.idSurtido ? 1 : -1))
        .map((a) => {
  return {
    _id: a._id,
    fecha: a.fecha,
    user: `${a.user?.[0]?.nombre || ""} ${a.user?.[0]?.apellido || ""}`.trim(),
    idUser: a.user?.[0]?._id || "",
    pedidos: a.pedidos?.[0]?.idPedido || "",
    idPedido: a.pedidos?.[0]?._id || "",
    clientes: a.pedidos?.[0]?.clientes?.[0]?.nombre_comercial || "",
    codigoClientes: a.pedidos?.[0]?.clientes?.[0]?.codigo || "",
    idClientes: a.pedidos?.[0]?.clientes?.[0]?._id || "",
    observaciones: a.observaciones || "",
    numero: a.idSurtido || "",
    comisionTDC: a.pedidos?.[0]?.comisionTDC || 0,
    comisionFlete: a.pedidos?.[0]?.comisionFlete || 0,
    impuestos: a.pedidos?.[0]?.impuestos || 0,
    subTotal: a.subTotal || 0,
    iva: a.iva || 0,
    total_general: a.total_general || 0,

    idDirEnt: a.pedidos?.[0]?.sucursales || [],
    alias: a.pedidos?.[0]?.sucursales?.[0]?.alias || "",
    calle: a.pedidos?.[0]?.sucursales?.[0]?.calle || "",
    numero_ext: a.pedidos?.[0]?.sucursales?.[0]?.numero_ext || "",
    numero_int: a.pedidos?.[0]?.sucursales?.[0]?.numero_int || "",
    pais: a.pedidos?.[0]?.sucursales?.[0]?.pais || "",
    estado: a.pedidos?.[0]?.sucursales?.[0]?.estado || "",
    ciudad: a.pedidos?.[0]?.sucursales?.[0]?.ciudad || "",
    delegacion: a.pedidos?.[0]?.sucursales?.[0]?.delegacion || "",
    colonia: a.pedidos?.[0]?.sucursales?.[0]?.colonia || "",
    cp: a.pedidos?.[0]?.sucursales?.[0]?.cp || "",
    RFC: a.pedidos?.[0]?.sucursales?.[0]?.RFC || "",

    paqueteria: a.paqueterias?.[0]?.name || "NA",
    idPaqueteria: a.paqueterias?.[0]?._id || "",

    area: a.pedidos?.[0]?.areas?.[0]?.name || "",
    vendedor: `${a.pedidos?.[0]?.colaboradores?.[0]?.nombre || ""} ${a.pedidos?.[0]?.colaboradores?.[0]?.apellido || ""}`.trim(),

    is_active: a.is_active ?? "",
    telefono: a.pedidos?.[0]?.clientes?.[0]?.telefono || "",
    autorizadoSurtido: a.autorizadoSurtido ?? ""
  };
})

          .filter(function (el) {
            return el != null;
          });

        let dataFinal = Object.values(arrayTabla);
        setSurtidos(allSurtidos);
        setComments(dataFinal);
        setCargando(false);
        Toast.close();
        //
      })
      .catch((err) => {
        console.log(err);
      });
  }, [selectedFechaInicio ,selectedFechaFin])

  const ListaSurtidos = comments.sort((a, b) =>
    a.idSurtido > b.idSurtido ? 1 : -1
  );

  function PDFTabla() {
    const data = ListaSurtidos.map((a) => {
      if (
        (selectedFechaInicio == 0 || selectedFechaInicio <= a.fecha) &&
        (selectedFechaFin == 0 || selectedFechaFin >= a.fecha) &&
        (activo == 0 || activo == a.is_active) &&
        (autorizadoSurtido == 0 || autorizadoSurtido == a.autorizadoSurtido) &&
        (selectedCliente == 0 || selectedCliente == a.idClientes)
      ) {
        return [a.numero, a.fecha, a.clientes, a.paqueteria, a.pedidos, a.user];
      }
    });
    const dataPDF = Object.values(data);
    const dataPDFLimpia = dataPDF.filter(function (el) {
      return el != null;
    });
    const doc = new jsPDF({compressPdf: true});
    var img = new Image();
    img.src = process.env.PUBLIC_URL + "Logo-Lynqro-PDF.png";
    doc.addImage(img, "png", 150, 5, 33, 10);
    var img2 = new Image();
    img2.src = process.env.PUBLIC_URL + "logoInstitucion.png";
    doc.addImage(img2, "png", 150, 15, 35, 30);
    doc.text(`Listado de Notas`, 20, 30);
    doc.text(`${selectedFechaInicio} - ${selectedFechaFin}`, 20, 40);
    doc.autoTable({
      head: [["Numero", "Fecha", "Cliente", "Paqueteria", "Pedido", "Surtio"]],
      body: dataPDFLimpia,
      startY: 50,
    });
    window.open(doc.output("bloburl"), "_blank");
  }

  function excel() {
    const dataExcel = ListaSurtidos.map((a) => {
      if (
        (selectedFechaInicio == 0 || selectedFechaInicio <= a.fecha) &&
        (selectedFechaFin == 0 || selectedFechaFin >= a.fecha) &&
        (activo == 0 || activo == a.is_active) &&
        (autorizadoSurtido == 0 || autorizadoSurtido == a.autorizadoSurtido) &&
        (selectedCliente == 0 || selectedCliente == a.idClientes)
      ) {
        return {
          Numero: a.numero,
          Fecha: a.fecha,
          Cliente: a.clientes,
          Pedido: a.pedidos,
          Surtio: a.user,
        };
      }
    });
    const dataExportExcel = Object.values(dataExcel);
    const dataExcelLimpia = dataExportExcel.filter(function (el) {
      return el != null;
    });

    var option = {};

    option.fileName = "ListadoNotas";

    option.datas = [
      {
        sheetData: dataExcelLimpia,
        sheetName: "ListadoNotas",
        sheetFilter: ["Numero", "Fecha", "Cliente", "Pedido", "Surtio"],
        sheetHeader: ["Numero", "Fecha", "Cliente", "Pedido", "Surtio"],
      },
    ];

    var toExcel = new ExportJsonExcel(option);
    toExcel.saveExcel();
  }

  function enviaMail() {
    const data = ListaSurtidos.map((a) => {
      if (
        (selectedFechaInicio == 0 || selectedFechaInicio <= a.fecha) &&
        (selectedFechaFin == 0 || selectedFechaFin >= a.fecha) &&
        (activo == 0 || activo == a.is_active) &&
        (autorizadoSurtido == 0 || autorizadoSurtido == a.autorizadoSurtido) &&
        (selectedCliente == 0 || selectedCliente == a.idClientes)
      ) {
        return [a.numero, a.fecha, a.clientes, a.pedidos, a.user];
      }
    });
    const dataPDF = Object.values(data);
    const dataPDFLimpia = dataPDF.filter(function (el) {
      return el != null;
    });
    const doc = new jsPDF({compressPdf: true});
    var img = new Image();
    img.src = process.env.PUBLIC_URL + "Logo-Lynqro-PDF.png";
    doc.addImage(img, "png", 150, 5, 33, 10);
    var img2 = new Image();
    img2.src = process.env.PUBLIC_URL + "logoInstitucion.png";
    doc.addImage(img2, "png", 150, 15, 35, 30);
    doc.text(`Listado de Notas`, 20, 30);
    doc.text(`${selectedFechaInicio} - ${selectedFechaFin}`, 20, 40);
    doc.autoTable({
      head: [["Numero", "Fecha", "Cliente", "Pedido", "Surtio"]],
      body: dataPDFLimpia,
      startY: 50,
    });
    var att = doc.output("arraybuffer");
    var base64File = encode(att);

    // Envia el Mail
    axios
      .post(
        URL_SEND_MAIL_ATT,
        {
          subject: "Listado de Notas",
          email: mailTo,
          fileName: "ListadoNotas.pdf",
          att: base64File,
          text: `<table border="0" cellpadding="0" cellspacing="0" width="100%">
         <th><img width="${process.env.REACT_APP_TAMANO_LOGO_MAIL}" align="center" src="${process.env.REACT_APP_LINK_SISTEMA}logoInstitucion.png" /></th>
         <tr align="center" style="font-size:30px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>${process.env.REACT_APP_NOMBRE_INSTITUCION}</tr>
         <tbody>
         <tr style="font-size:20px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>Hola,</tr>
         <tr style="font-size:20px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>Adjunto encontraras el listado de Notas.</tr>
         </tbody>
         <tr style="font-size:16px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px"><br>Favor de no responder este correo, para cualquier duda favor de comunicarse al ${process.env.REACT_APP_TELEFONO_INSTITUCION}</tr>
         <tr align="right"><br>Powered by <a href="https://lynqro.com"> <img width="20%" align="center" src="${process.env.REACT_APP_LINK_SISTEMA}Logo-Lynqro-PDF.png" /> </a> </tr>
         </table>`,
        },
        {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        }
      )
      .then(() => {
        toggleMail();
        Swal.fire("Good job!", "Enviado con exito", "success");
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
          footer: `${error.response.data}`,
        });
        console.log(error);
      });
  }

  async function PDFOC(
    fecha,
    idClientes,
    clientes,
    observaciones,
    numero,
    idPDFOC,
    user,
    pedidos,
    comisionTDC,
    comisionFlete,
    impuestos,
    subTotal,
    iva,
    total_general,
    alias,
    calle,
    numero_ext,
    numero_int,
    pais,
    estado,
    ciudad,
    delegacion,
    colonia,
    cp,
    RFC,
    paqueteria,
    area,
    codigoClientes,
    vendedor,
    telefono,
    autorizadoSurtido
  ) {
    await axios
      .get(`${URL_ARTICULOS_SURTIDOS}/surtido/${idPDFOC}`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allArticulosSurtido = response.data;
        let arrayTabla = allArticulosSurtido
          .map((a) => {
            const art = a.articulos?.[0];
            if (!art) return null;
            return {
              id: a.inventarios?.[0]?._id || a._id,
              articulos: `${art.SKU || ""} ${art.nombre || ""}`.trim(),
              cantidad: a.cantidad,
              idArticulo: art._id,
              precio: a.precio,
              precioBruto: a.precioBruto,
              totalPrecioBruto: a.cantidad * a.precioBruto,
              // precioOriginal: a.articulos[0].venta,
              cajas: art.piezasPorCaja ? a.cantidad / art.piezasPorCaja : 0,
              cliente: a.articulosPedido?.[0]?.cliente || "",
            };
          })
          .filter(function (el) {
            return el != null;
          });

        let dataFinal = Object.values(arrayTabla);

        // let agrupado = dataFinal.reduce(function (groups, item) {
        //   const val = item["idArticulo"];
        //   groups[val] = groups[val] || {
        //     idArticulo: item.idArticulo,
        //     cantidad: 0,
        //     cajas: 0,
        //   };
        //   groups[val].cantidad += item.cantidad;
        //   groups[val].cajas += item.cajas;
        //   groups[val].articulos = item.articulos;
        //   groups[val].precio = item.precio;
        //   groups[val].precioOriginal = item.precioOriginal;
        //   return groups;
        // }, []);

        // let agrupadoValues = Object.values(agrupado);

        let totalMts = dataFinal.map((c) => parseFloat(c.cantidad));
        let TM = totalMts.reduce((t, total, index) => t + total, 0);

        let TC = dataFinal.map((c) => parseFloat(c.cajas));
        let TTC = TC.reduce((t, total, index) => t + total, 0);

        let TBruto = dataFinal.map((c) => parseFloat(c.totalPrecioBruto));
        let TTB = TBruto.reduce((t, totalPrecioBruto, index) => t + totalPrecioBruto, 0);

        let totalParcial = 0;

        const data = dataFinal.map((a) => {
          totalParcial = a.cantidad * a.precio;
          return [
            a.articulos,
            new Intl.NumberFormat("en-US").format(a.cajas.toFixed(2)),
            new Intl.NumberFormat("en-US").format(a.cantidad),
            a.cliente,
            // new Intl.NumberFormat("en-US", {
            //   style: "currency",
            //   currency: "USD",
            //   maximumFractionDigits: 2,
              
            // }).format(a.precioOriginal),
            new Intl.NumberFormat("en-US", {
              style: "currency",
              currency: "USD",
              maximumFractionDigits: 2,
              
            }).format(a.precio),
            new Intl.NumberFormat("en-US", {
              style: "currency",
              currency: "USD",
              maximumFractionDigits: 2,
              
            }).format(a.totalPrecioBruto),
            new Intl.NumberFormat("en-US", {
              style: "currency",
              currency: "USD",
              maximumFractionDigits: 2,
              
            }).format(totalParcial),
          ];
        });

        const dataPDF = Object.values(data);
        const dataPDFLimpia = dataPDF.filter(function (el) {
          return el != null;
        });
        const doc = new jsPDF({compressPdf: true});
        // var img = new Image();
        // img.src = process.env.PUBLIC_URL + "Logo-Lynqro-PDF.png";
        // doc.addImage(img, "png", 8, 5, 18, 5);
        var img2 = new Image();
        img2.src = process.env.PUBLIC_URL + "logoInstitucion.png";
        doc.addImage(img2, "png", 10, 11, 20, 15);

        doc.setFontSize(12);
        doc.text(`Fecha:`, 35, 15);
        doc.text(`${fecha}`, 60, 15);
        doc.text(`Nota:`, 35, 20);
        doc.text(`${numero}`, 60, 20);
        doc.text(`Pedido:`, 35, 25);
        doc.text(`${pedidos}`, 60, 25);

        doc.text(`Ejecutivo:`, 90, 15);
        doc.text(`${vendedor}`, 115, 15);
        doc.text(`Almacen:`, 90, 20);
        doc.text(`${area}`, 115, 20);
        doc.text(`Paqueteria:`, 90, 25);
        doc.text(`${paqueteria}`, 115, 25);

        if(autorizadoSurtido == "Si"){
          doc.text(`AUTORIZADO`, 150, 40);
        }

        doc.setFontSize(8);
        doc.text(`Cliente: ${codigoClientes} - ${clientes}`, 10, 32);
        // doc.text(`RFC: ${RFC}`, 150, 32);
        doc.text(`Sucursal: ${alias}`, 10, 37);
        doc.text(
          `Direccion de Envio: ${calle} #${numero_ext} Int. ${numero_int} Telefono: ${telefono}`,
          10,
          42
        );
        // doc.text(
        //   `Edo: ${estado}, Ciudad: ${ciudad}, Del: ${delegacion}, Col: ${colonia}, CP: ${cp} Paqueteria: ${paqueteria}`,
        //   10,
        //   47
        // );

        doc.autoTable({
          head: [
            [
              "Articulo",
              "Cajas",
              "Cantidad",
              "Cliente",
              // "Precio Original",
              "Precio",
              "Total Precio Bruto",
              "Total",
            ],
          ],
          body: dataPDFLimpia,
          styles: {
            fontSize: 8,
            // overflow: "linebreak",
            // columnWidth: "wrap",
            // // font: 'arial',
            // overflowColumns: "linebreak",
          },
          margin: { left: 5, right: 5 },
          startY: 50,
          footStyles: {
            fontSize: 9,
            fillColor: [255, 255, 255],
            textColor: [0, 0, 0],
          },
          foot: [
            [
              "",
              new Intl.NumberFormat("en-US").format(TTC.toFixed(2)) + " Cajas",
              new Intl.NumberFormat("en-US").format(TM) + " Piezas",
              "",
              "",
              // "",
              "Sub Total",
              new Intl.NumberFormat("en-US", {
                style: "currency",
                currency: "USD",
                maximumFractionDigits: 2,
              }).format(subTotal.toFixed(2)),
            ],
            [
              "",
              "",
              "",
              "",
              // "",
              "",
              `Comision`,
              new Intl.NumberFormat("en-US", {
                style: "currency",
                currency: "USD",
                maximumFractionDigits: 2,
              }).format(iva.toFixed(2)),
            ],
            [
              "",
              "",
              "",
              // "",
              "",
              "",
              "Comision TDC",
              new Intl.NumberFormat("en-US", {
                style: "currency",
                currency: "USD",
                maximumFractionDigits: 2,
              }).format(comisionTDC.toFixed(2)),
            ],
            [
              "",
              "",
              "",
              // "",
              "",
              "",
              "Comision Flete",
              new Intl.NumberFormat("en-US", {
                style: "currency",
                currency: "USD",
                maximumFractionDigits: 2,
              }).format(comisionFlete.toFixed(2)),
            ],
            [
              "",
              "",
              // "",
              "",
              "",
              "",
              "Total",
              new Intl.NumberFormat("en-US", {
                style: "currency",
                currency: "USD",
                maximumFractionDigits: 2,
              }).format(total_general.toFixed(2)),
            ],
            [
              "",
              "",
              // "",
              "",
              "",
              "",
              "Total Bruto",
              new Intl.NumberFormat("en-US", {
                style: "currency",
                currency: "USD",
                maximumFractionDigits: 2,
              }).format(TTB.toFixed(2)),
            ],
          ],
          showFoot: "lastPage",
        });

        window.open(doc.output("bloburl"), "_blank");
        //   }
        // });
        // });
      })
      .catch((err) => {
        console.log(err);
      });
  }

  async function excelFOC(
    fecha,
    idClientes,
    clientes,
    observaciones,
    numero,
    idPDFOC,
    user,
    pedidos,
    comisionTDC,
    comisionFlete,
    impuestos,
    subTotal,
    iva,
    total_general,
    alias,
    calle,
    numero_ext,
    numero_int,
    pais,
    estado,
    ciudad,
    delegacion,
    colonia,
    cp,
    RFC,
    paqueteria,
    area,
    codigoClientes
  ) {
    await axios
      .get(`${URL_ARTICULOS_SURTIDOS}/surtido/${idPDFOC}`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allArticulosSurtido = response.data;
        let arrayTabla = allArticulosSurtido
          .map((a) => {
            return {
              id: a.inventarios[0]._id,
              articulos: a.articulos[0].MLM + " " + a.articulos[0].nombre,
              cantidad: a.cantidad,
              idArticulo: a.articulos[0]._id,
              precio: a.articulosPedido[0].precio,
            };
          })
          .filter(function (el) {
            return el != null;
          });
        let dataFinal = Object.values(arrayTabla);
        let agrupado = dataFinal.reduce(function (groups, item) {
          const val = item["idArticulo"];
          groups[val] = groups[val] || {
            idArticulo: item.idArticulo,
            cantidad: 0,
          };
          groups[val].cantidad += item.cantidad;
          groups[val].articulos = item.articulos;
          groups[val].precio = item.precio;
          return groups;
        }, []);
        let agrupadoValues = Object.values(agrupado);
        let totalMts = agrupadoValues.map((c) => parseFloat(c.cantidad));
        let TM = totalMts.reduce((t, total, index) => t + total, 0);
        let totalParcial = 0;
        const data = agrupadoValues.map((a) => {
          totalParcial = a.cantidad * a.precio;
          return {
            Articulos: a.articulos,
            Cantidad: a.cantidad,
            Precio: a.precio,
            TotalParcial: totalParcial,
          };
        });
        const dataExportExcel = Object.values(data);
        const dataExcelLimpia = dataExportExcel.filter(function (el) {
          return el != null;
        });

        const data2 = [
          {
            Cliente: codigoClientes + " " + clientes,
            Nota: numero,
            RFC: RFC,
            Direccion:
              calle +
              " " +
              numero_int +
              " " +
              numero_ext +
              " " +
              estado +
              " " +
              ciudad +
              " " +
              delegacion +
              " " +
              colonia +
              " " +
              cp,
            Impuestos: impuestos,
            IVA: iva,
            TotalGeneral: total_general,
            ComisionTDC: comisionTDC,
            ComisionFlete: comisionFlete,
            Fecha: fecha,
            Observaciones: observaciones,
          },
        ];

        var option = {};
        option.fileName = `Nota ${numero}`;
        option.datas = [
          {
            sheetData: data2,
            sheetName: `Datos Generales`,
            sheetFilter: [
              "Nota",
              "Fecha",
              "Cliente",
              "RFC",
              "Direccion",
              "Impuestos",
              "IVA",
              "TotalGeneral",
              "ComisionTDC",
              "ComisionFlete",
              "Observaciones",
            ],
            sheetHeader: [
              "Nota",
              "Fecha",
              "Cliente",
              "RFC",
              "Direccion",
              "Impuestos",
              "IVA",
              "TotalGeneral",
              "ComisionTDC",
              "ComisionFlete",
              "Observaciones",
            ],
          },
          {
            sheetData: dataExcelLimpia,
            sheetName: `Articulos`,
            sheetFilter: ["Articulos", "Cantidad", "Precio", "TotalParcial"],
            sheetHeader: ["Articulos", "Cantidad", "Precio", "TotalParcial"],
          },
        ];

        var toExcel = new ExportJsonExcel(option);
        toExcel.saveExcel();
      })
      .catch((err) => {
        console.log(err);
      });
  }

  const headers = [
    { name: "Numero", field: "numero", sortable: true },
    { name: "Fecha", field: "fecha", sortable: true },
    { name: "Cliente", field: "clientes", sortable: true },
    { name: "Paqueteria", field: "paqueteria", sortable: true },
    { name: "Almacen", field: "area", sortable: true },
    { name: "Vendedor", field: "vendedor", sortable: true },
    { name: "Pedido", field: "pedidos", sortable: true },
    { name: "Surtió", field: "user", sortable: true },
    { name: "Detalles", field: "acciones", sortable: false },
  ];

  const commentsData = useMemo(() => {
    let computedComments = comments;

    if (search) {
      computedComments = computedComments.filter(
        (comment) =>
          comment.user.toLowerCase().includes(search.toLowerCase()) ||
          comment.clientes.toLowerCase().includes(search.toLowerCase()) ||
          comment.area.toLowerCase().includes(search.toLowerCase()) ||
          comment.vendedor.toLowerCase().includes(search.toLowerCase()) ||
          comment.paqueteria.toLowerCase().includes(search.toLowerCase()) ||
          comment.pedidos.toString().includes(search) ||
          comment.numero.toString().includes(search)
      );
    }
    if (selectedCliente) {
      computedComments = computedComments.filter((e) =>
        e.idClientes.includes(selectedCliente)
      );
    }
    if (selectedUser) {
      computedComments = computedComments.filter((e) =>
        e.idUser.includes(selectedUser)
      );
    }

    if (selectedFechaInicio) {
      computedComments = computedComments.filter(
        (e) => e.fecha >= selectedFechaInicio
      );
    }

    if (selectedFechaFin) {
      computedComments = computedComments.filter(
        (e) => e.fecha <= selectedFechaFin
      );
    }
    if (autorizadoSurtido) {
      computedComments = computedComments.filter((e) =>
        e.autorizadoSurtido.includes(autorizadoSurtido)
      );
    }

    setTotalItems(computedComments.length);

    //Sorting comments
    if (
      sorting.field &&
      sorting.field != "pedidos" &&
      sorting.field != "numero"
    ) {
      const reversed = sorting.order === "asc" ? 1 : -1;
      computedComments = computedComments.sort(
        (a, b) => reversed * a[sorting.field].localeCompare(b[sorting.field])
      );
    }

    if (
      sorting.field &&
      sorting.order === "asc" &&
      (sorting.field == "pedidos" || sorting.field == "numero")
    ) {
      computedComments = computedComments.sort((a, b) =>
        parseFloat(a[sorting.field]) > parseFloat(b[sorting.field]) ? 1 : -1
      );
    }

    if (
      sorting.field &&
      sorting.order === "desc" &&
      (sorting.field == "pedidos" || sorting.field == "numero")
    ) {
      computedComments = computedComments.sort((a, b) =>
        parseFloat(a[sorting.field]) < parseFloat(b[sorting.field]) ? 1 : -1
      );
    }

    //Current Page slice
    return computedComments.slice(
      (currentPage - 1) * ITEMS_PER_PAGE,
      (currentPage - 1) * ITEMS_PER_PAGE + ITEMS_PER_PAGE
    );
  }, [
    comments,
    currentPage,
    search,
    sorting,
    selectedCliente,
    selectedUser,
    selectedFechaInicio,
    selectedFechaFin,
    autorizadoSurtido
  ]);

  function autorizar(id) {
    const URL_AUTORIZADO = `${URL_SURTIDOS}/${id}`;
    Swal.fire({
      title: "Estas seguro?",
      text: "Se guardara!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Si, guardar!",
    }).then((result) => {
      if (result.isConfirmed) {
        axios
          .patch(
            URL_AUTORIZADO,
            {
              autorizadoSurtido: "Si",
            },
            {
              headers: {
                Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
              },
            }
          )
          .then(()=>{
            Swal.fire("Good job!", "Autorizado", "success");
            setTimeout(() => {
              window.location.reload();
            }, 1000);
          }).catch((error) => {
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: "Something went wrong!",
              footer: `${error.response.data}`,
            });
            console.log(error);
          })
      }
    });
  }

  function QRGen(id, cliente, numero, paqueteria) {
    axios
      .get(`${URL_ARTICULOS_SURTIDOS}/surtido/${id}`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then(async (response) => {
        let allRollos = response.data;
        setRollos(allRollos);
  
        const doc = new jsPDF("landscape", "mm", [55, 40]);
  
        for (const a of allRollos) {
          const codigo = a._id;
  
          // Generar código QR como base64
          const base64 = await qrcode.toDataURL(codigo);
  
          // Generar tantas hojas como indique 'cantidad'
          for (let i = 0; i < a.cantidad; i++) {
            const img3 = new Image();
            img3.src = base64;
  
            // Agregar el código QR y detalles al PDF
            doc.addImage(img3, "png", 13, 14, 25, 25);
            doc.setFontSize(8);
            doc.text(`Cliente: ${cliente}`, 3, 7.5);
            doc.text(`Articulo: ${a.articulos[0].SKU}`, 3, 11);
            doc.text(`Paqueteria: ${paqueteria}`, 3, 14.5);
  
            // Agregar una nueva página para la siguiente
            doc.addPage();
          }
        }
  
        // Guardar el PDF
        window.open(doc.output("bloburl"), "_blank");
      })
      .catch((err) => {
        console.log(err);
      });
  }
  

  function entregar(){
    setInputFields([
      {
        id: uuidv4(),
        _id: "",
        articulo: "",
        cliente: "",
      },
    ]);

      toggleEntregar();
  
  }
  function jalaPaqueteria(id) {
    // Set the selected paqueteria
    setSelectedPaqueteria(id);
    toggleProgreso()
    axios
        .get(`${URL_ARTICULOS_SURTIDOS}entregarPaqueteria/${id}`, {
            headers: {
                Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
            },
        })
        .then((response) => {
            let allArticulos = response.data;
            setArticulos(allArticulos);

            // Obtener los _id de cada paquetería
            let result = allArticulos.map(({ _id }) => _id);
            setIdsArticulo(result); // Guardar los ids obtenidos
            setModalProgreso(false)
        })
        .catch((err) => {
            console.log(err);
        });
}

function BuscaArticulo(id, event) {
  if (event.target.value.length >= 24) {
    if (idsArticulo.includes(event.target.value)) {
      // if (
      //   inputFields.filter((e) => e._id == event.target.value)
      //     .length > 0
      // ) {
      //   Swal.fire({
      //     icon: "error",
      //     title: "Oops...",
      //     text: "El articulo ya fue escaneado!",
      //     showConfirmButton: false,
      //   });
      //   const newInputFields = inputFields.map((i) => {
      //     if (id === i.id) {
      //       i._id = "";
      //     }
      //     return i;
      //   });
      //   setInputFields(newInputFields);
      // } else {
        articulos.map((a) => {
          if (a._id == event.target.value) {
            let _id = a._id;
            let articulo = a.articulos[0].MLM + " " + a.articulos[0].nombre;
            let cliente = a.clientes[0].nombre_comercial;
            handleChangeInputSurtido(
              id,
              _id,
              articulo,
              cliente
            );
          }
        });
      // }
    } else {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "El surtido no pertenece a la paqueteria!",
        showConfirmButton: false,
      });
      const newInputFields = inputFields.map((i) => {
        if (id === i.id) {
          i._id = "";
        }
        return i;
      });
      setInputFields(newInputFields);
    }
  } else {
    const newInputFields = inputFields.map((i) => {
      if (id === i.id) {
        i._id = event.target.value;
      }
      return i;
    });
    setInputFields(newInputFields);
  }
}

const handleChangeInputSurtido = (
  id,
  _id,
  articulo,
  cliente
) => {
  const newInputFields = inputFields.map((i) => {
    if (id === i.id) {
      i._id = _id;
      i.articulo = articulo;
      i.cliente = cliente;
    }
    return i;
  });
  setInputFields(newInputFields);
  handleAddFields();
};

const handleAddFields = () => {
  setInputFields([
    ...inputFields,
    {
      id: uuidv4(),
      _id: "",
      articulo: "",
      cliente: "",
    },
  ]);
};

const saveEntregar = async () => {
  // event.preventDefault();
  // setValidaBoton(false);
  // toggleProgreso();
  let totalPedido = inputFields.length

  try {
        inputFields.map((a) => {
          if(a._id != ""){
          axios.patch(
            `${URL_ARTICULOS_SURTIDOS}Entrega/${a._id}`,
            {
              entregadoCantidad: 1
            },
            {
              headers: {
                Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
              },
            }
          )
          .then(()=>{
            totalPedido = totalPedido -1
            if(totalPedido == 0 ){
                  Swal.fire("Good job!", "Creado con exito", `success`);
                  setTimeout(() => {
                    window.location.reload();
                  }, 1000);
            }
          })
        }else{ 
          totalPedido = totalPedido -1
          if(totalPedido == 0 ){
                Swal.fire("Good job!", "Creado con exito", `success`);
                setTimeout(() => {
                  window.location.reload();
                }, 1000);
          }
        }
        });
  } catch (error) {
    Swal.fire({
      icon: "error",
      title: "Oops...",
      text: "Something went wrong!",
      footer: `${error.response.data}`,
    });
    console.log(error);
  }
};

  const sec = { borderLeft: "4px solid #3b82f6", paddingLeft: 12, marginBottom: 8, color: "#1e3a8a", fontWeight: 600, fontSize: "0.85rem", textTransform: "uppercase", letterSpacing: "0.05em" };
  const block = { background: "#f8fafc", borderRadius: 8, padding: "12px 16px", marginBottom: 14 };


  function abrirIMEISurtido(id, numero, fecha) {
    setImeiDocId(id);
    setImeiDocNumero(numero);
    setImeiDocFecha(fecha);
    setNewIMEI("");
    setNewIMEIArticulo("");
    axios.get(`${URL_IMEIS}BySurtido/${id}`, {
      headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` },
    }).then((res) => {
      setImeisList(res.data);
      setModalIMEI(true);
    }).catch(() => { setImeisList([]); setModalIMEI(true); });
  }

  function guardarIMEISurtido() {
    if (!newIMEI.trim()) return;
    axios.post(URL_IMEIS, {
      imei: newIMEI.trim(),
      articuloNombre: newIMEIArticulo || "NA",
      tipo: "Salida",
      surtidos: imeiDocId,
      fecha: imeiDocFecha,
    }, {
      headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` },
    }).then((res) => {
      setImeisList(prev => [...prev, res.data]);
      setNewIMEI("");
      setNewIMEIArticulo("");
    }).catch((err) => console.log(err));
  }

  return (
    <>
      <Header />
      <br />
      <br />
      {user.menu_surtidos ? (
        <div className="card col-12">
          {/* Toolbar */}
          <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", padding: "10px 16px 6px" }}>
            <h4 style={{ margin: 0, fontWeight: 700, color: "#1e3a8a" }}>📋 Notas de Surtido</h4>
            <div style={{ display: "flex", gap: 8, alignItems: "center" }}>
              <Button size="sm" href="/MenuVentas" className="btn btn-danger">← Regresar</Button>
              <ButtonGroup>
                <Button size="sm" color="danger" onClick={PDFTabla}>PDF <i className="far fa-file-pdf"></i></Button>
                <Button size="sm" color="info" onClick={toggleMail}>eMail <i className="fas fa-at"></i></Button>
                <Button size="sm" color="primary" onClick={excel}>Excel <i className="far fa-file-excel"></i></Button>
              </ButtonGroup>
            </div>
          </div>

          {/* Filters */}
          <div style={block}>
            <div style={sec}>Filtros</div>
            <Row>
              <Col md={2}>
                <Label style={{ fontSize: "0.8rem" }}>Fecha Inicio</Label>
                <Input bsSize="sm" type="date" value={selectedFechaInicio} required onChange={(e) => setSelectedFechaInicio(e.target.value)} />
              </Col>
              <Col md={2}>
                <Label style={{ fontSize: "0.8rem" }}>Fecha Fin</Label>
                <Input bsSize="sm" type="date" value={selectedFechaFin} required onChange={(e) => setSelectedFechaFin(e.target.value)} />
              </Col>
              <Col md={3}>
                <Label style={{ fontSize: "0.8rem" }}>Cliente</Label>
                <Input bsSize="sm" type="select" value={selectedCliente} onChange={(e) => { setSelectedCliente(e.target.value); setCurrentPage(1); }}>
                  <option value="">Todos</option>
                  {clientes.sort((a, b) => a.nombre_comercial > b.nombre_comercial ? 1 : -1).map((a) => (
                    <option key={a._id} value={a._id}>{a.nombre_comercial}</option>
                  ))}
                </Input>
              </Col>
              <Col md={2}>
                <Label style={{ fontSize: "0.8rem" }}>Autorizado</Label>
                <Input bsSize="sm" type="select" value={autorizadoSurtido} onChange={(e) => { setAutorizadoSurtido(e.target.value); setCurrentPage(1); }}>
                  <option value="">Todos</option>
                  <option value="Si">Si</option>
                  <option value="No">No</option>
                </Input>
              </Col>
              <Col md={3}>
                <Label style={{ fontSize: "0.8rem" }}>Buscar</Label>
                <Search onSearch={(value) => { setSearch(value); setCurrentPage(1); }} />
              </Col>
            </Row>
          </div>

          {/* Pagination + badge */}
          <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 6 }}>
            <Pagination total={totalItems} itemsPerPage={ITEMS_PER_PAGE} currentPage={currentPage} onPageChange={(page) => setCurrentPage(page)} />
            <span style={{ background: "#dbeafe", color: "#1e3a8a", borderRadius: 20, padding: "3px 14px", fontWeight: 700, fontSize: "0.85rem" }}>
              {commentsData.length} notas
            </span>
          </div>

          <Table size="sm" bordered striped className="table-responsive-xl" style={{ fontSize: "0.82rem" }}>
            <TableHeader headers={headers} onSorting={(field, order) => setSorting({ field, order })} />
            <tbody>
              {commentsData.map((a) => {
                const rowBg = a.is_active === "No"
                  ? { backgroundColor: "#fee2e2" }
                  : a.autorizadoSurtido === "Si"
                  ? { backgroundColor: "#dcfce7" }
                  : {};
                if (a.is_active === "No") {
                  return (
                    <tr key={a._id} style={rowBg}>
                      <td>{a.numero}</td>
                      <td>{a.fecha}</td>
                      <td>{a.clientes}</td>
                      <td>{a.paqueteria}</td>
                      <td>{a.area}</td>
                      <td>{a.vendedor}</td>
                      <td>{a.pedidos}</td>
                      <td>{a.user}</td>
                      <td>
                        <span style={{ color: "#b91c1c", fontWeight: 700, marginRight: 6 }}>CANCELADA</span>
                        <Button size="sm" color="danger" onClick={(e) => PDFOC(a.fecha, a.idClientes, a.clientes, a.observaciones, a.numero, a._id, a.user, a.pedidos, a.comisionTDC, a.comisionFlete, a.impuestos, a.subTotal, a.iva, a.total_general, a.alias, a.calle, a.numero_ext, a.numero_int, a.pais, a.estado, a.ciudad, a.delegacion, a.colonia, a.cp, a.RFC, a.paqueteria, a.area, a.codigoClientes, a.vendedor, a.telefono)}>
                          <i className="far fa-file-pdf"></i>
                        </Button>
                      </td>
                    </tr>
                  );
                }
                return (
                  <tr key={a._id} style={rowBg}>
                    <td>{a.numero}</td>
                    <td>{a.fecha}</td>
                    <td>{a.clientes}</td>
                    <td>{a.paqueteria}</td>
                    <td>{a.area}</td>
                    <td>{a.vendedor}</td>
                    <td>{a.pedidos}</td>
                    <td>{a.user}</td>
                    <td>
                      <Button size="sm" color="danger" onClick={(e) => PDFOC(a.fecha, a.idClientes, a.clientes, a.observaciones, a.numero, a._id, a.user, a.pedidos, a.comisionTDC, a.comisionFlete, a.impuestos, a.subTotal, a.iva, a.total_general, a.alias, a.calle, a.numero_ext, a.numero_int, a.pais, a.estado, a.ciudad, a.delegacion, a.colonia, a.cp, a.RFC, a.paqueteria, a.area, a.codigoClientes, a.vendedor, a.telefono, a.autorizadoSurtido)}>
                        <i className="far fa-file-pdf"></i>
                      </Button>
                      {" "}
                      <Button size="sm" color="primary" onClick={(e) => excelFOC(a.fecha, a.idClientes, a.clientes, a.observaciones, a.numero, a._id, a.user, a.pedidos, a.comisionTDC, a.comisionFlete, a.impuestos, a.subTotal, a.iva, a.total_general, a.alias, a.calle, a.numero_ext, a.numero_int, a.pais, a.estado, a.ciudad, a.delegacion, a.colonia, a.cp, a.RFC, a.paqueteria, a.area, a.codigoClientes)}>
                        <i className="far fa-file-excel"></i>
                      </Button>
                      {" "}
                      <Button size="sm" color="secondary" title="Registrar IMEIs" onClick={() => abrirIMEISurtido(a._id, a.numero, a.fecha)}>
                        📱 IMEI
                      </Button>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </Table>
          <div className="col-md-6">
            <Pagination total={totalItems} itemsPerPage={ITEMS_PER_PAGE} currentPage={currentPage} onPageChange={(page) => setCurrentPage(page)} />
          </div>
        </div>
      ) : undefined}
      <br />

      {/* Mail Modal */}
      <Modal size="sm" isOpen={modalMail} toggle={toggleMail}>
        <ModalHeader toggle={toggleMail}>
          <h4>Enviar Listado de Notas</h4>
        </ModalHeader>
        <ModalBody>
          <Label className="mr-sm-2">Email</Label>
          <Input className="col-sm-12" type="text" value={mailTo} required onChange={(e) => setMailTo(e.target.value)} />
        </ModalBody>
        <ModalFooter>
          <Button size="sm" color="success" onClick={enviaMail}>Enviar</Button>
        </ModalFooter>
      </Modal>

      {/* Entregar Modal */}
      <Modal size="xxl" isOpen={modalEntregar} toggle={toggleEntregar}>
        <ModalHeader toggle={toggleEntregar}>
          <h4>Entregar Guias</h4>
        </ModalHeader>
        <ModalBody>
          <Row>
            <Col md={3}>
              <Label className="mr-sm-2">Paqueteria</Label>
              <Input className="col-sm-12" bsSize="sm" type="select" value={selectedPaqueteria} required onChange={(e) => jalaPaqueteria(e.target.value)}>
                <option value="">Selecciona</option>
                {paqueterias.sort((a, b) => a.name > b.name ? 1 : -1).map((a) => (
                  <option key={a._id} value={a._id}>{a.name}</option>
                ))}
              </Input>
            </Col>
          </Row>
          <br />
          <Row>
            <Col md={3}><Label className="mr-sm-2">Codigo</Label></Col>
            <Col md={4}><Label className="mr-sm-2">Surtido</Label></Col>
            <Col md={5}><Label className="mr-sm-2">Cliente</Label></Col>
          </Row>
          {inputFields.map((inputField) => (
            <div key={inputField.id}>
              <Row>
                <Col md={3}>
                  <Input bsSize="sm" name="_id" type="string" value={inputField._id} onChange={(event) => BuscaArticulo(inputField.id, event)} />
                </Col>
                <Col md={4}>
                  <Input bsSize="sm" name="articulo" type="string" value={inputField.articulo} disabled />
                </Col>
                <Col md={5}>
                  <Input bsSize="sm" name="cliente" type="string" value={inputField.cliente} disabled />
                </Col>
              </Row>
            </div>
          ))}
          <br />
          <Button size="sm" color="success" onClick={(e) => saveEntregar()}>Guardar</Button>
        </ModalBody>
      </Modal>

      {/* Progreso Modal */}
      <Modal size="sm" isOpen={modalProgreso} toggle={toggleProgreso}>
        <ModalHeader toggle={toggleProgreso}><h4>Progreso</h4></ModalHeader>
        <ModalBody>
          <h4>Este proceso puede tardar varios segundos.<br />Por favor no cierre ni refresque su navegador.</h4>
          <br />
          <div className="progreso">
            <Spinner style={{ width: "50px", height: "50px", color: "#232B41" }} />
            <Spinner style={{ width: "50px", height: "50px", color: "#232B41" }} />
            <Spinner style={{ width: "50px", height: "50px", color: "#232B41" }} />
          </div>
        </ModalBody>
      </Modal>


      {/* Modal IMEIs Surtidos */}
      <Modal size="lg" isOpen={modalIMEI} toggle={toggleIMEI}>
        <ModalHeader toggle={toggleIMEI}><h4>📱 IMEIs — Surtido #{imeiDocNumero}</h4></ModalHeader>
        <ModalBody>
          <Row>
            <Col md={4}>
              <Label>Artículo</Label>
              <Input
                type="text"
                placeholder="Nombre del artículo"
                value={newIMEIArticulo}
                onChange={(e) => setNewIMEIArticulo(e.target.value)}
              />
            </Col>
            <Col md={5}>
              <Label>IMEI / Número de serie</Label>
              <Input
                type="text"
                placeholder="Escanear o escribir IMEI y presionar Enter"
                value={newIMEI}
                onChange={(e) => setNewIMEI(e.target.value)}
                onKeyDown={(e) => { if (e.key === "Enter") guardarIMEISurtido(); }}
                autoFocus
              />
            </Col>
            <Col md={3} className="d-flex align-items-end">
              <Button color="success" size="sm" onClick={guardarIMEISurtido}>+ Agregar</Button>
            </Col>
          </Row>
          <br />
          <Table size="sm" bordered striped style={{ fontSize: "0.82rem" }}>
            <thead className="thead-light">
              <tr>
                <th>#</th>
                <th>Artículo</th>
                <th>IMEI</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {imeisList.map((i, idx) => (
                <tr key={i._id}>
                  <td>{idx + 1}</td>
                  <td>{i.articuloNombre}</td>
                  <td><b>{i.imei}</b></td>
                  <td>
                    <Button size="sm" color="danger" onClick={() => {
                      axios.delete(`${URL_IMEIS}/${i._id}`, { headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` }});
                      setImeisList(imeisList.filter(x => x._id !== i._id));
                    }}><i className="fas fa-trash"></i></Button>
                  </td>
                </tr>
              ))}
              {imeisList.length === 0 && (
                <tr><td colSpan={4} className="text-center text-muted">Sin IMEIs registrados</td></tr>
              )}
            </tbody>
          </Table>
        </ModalBody>
        <ModalFooter>
          <Button color="primary" onClick={toggleIMEI}>Cerrar</Button>
        </ModalFooter>
      </Modal>

      {loader}
    </>
  );
}

export default ListadoSurtidos;
